import { useMutation, useQueryClient } from '@tanstack/react-query';
import { detachDealersFromGroup } from '../services/security-groups';

export function useDetachDealersMutation(groupId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dealerIds: string[]) => detachDealersFromGroup(groupId, dealerIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId, 'dealers'] });
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId] });
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
    },
  });
}
